export default {
  SET_CONTACTS(state, contacts) {
    contacts.forEach((element) => {
      element.notifications = 0;
    });
    state.contacts = contacts;
  },

  SET_ACTIVE_CHAT(state, contact) {
    state.activeChat = contact;
    const index = state.contacts.findIndex((x) => x.phone === contact.phone);
    if (index !== -1) {
      state.contacts[index].notifications = 0;
    }
  },

  SET_MESSAGES(state, messages) {
    state.messages = messages;
  },

  ADD_NEW_MESSAGE(state, message) {
    if (!message) return;
    const newMessage = [message];
    state.messages = [...state.messages, ...newMessage];
  },

  INCREMENT_NOTIFICATION(state, contact) {
    const index = state.contacts.findIndex((x) => x.phone === contact.phone);
    if (index !== -1) {
      state.contacts[index].notifications += 1;
    } else {
      state.contacts.unshift(contact);
    }
  },

  SHOW_CHATS(state, payload) {
    state.showChats = payload;
  },

  SHOW_CONTACTS(state, payload) {
    state.showContacts = payload;
  },

  ADD_AGENT_MESSAGES(state, messages) {
    if (!messages) return;
    state.agentMessages = messages;
  },

  SET_SEARCH_TERM(state, payload) {
    state.searchTerm = payload;
  },
  // SET_FILTER_RESULT(state, payload) {
  //   state.filterContact = payload;
  // },

  SET_SEARCH_RESULTS(state, payload) {
    state.searchResults = payload;
  },
  CHECK_EXP_STATUS(state, payload) {
    state.expStatus = payload;
  },
  REFRESH_PAGE(state, payload) {
    console.log("payloadpayload", payload);
    state.refreshPage = payload.refreshPage;
  },
  HANDLE_CHECKBOX(state, payload) {
    state.audiencecheckbox = payload;
  },
  HANDLE_CHECKBOX_TRUE(state, payload) {
    state.checktrue = payload;
  },
};
